export default "__VITE_ASSET__oj8Zl19Q__"